import { LogoutIcon } from "components/icons/Icons";
import { NsKey } from "enums/NsKey";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { DashboardMenuItemTooltip } from "./DashboardMenuItemTooltip";

const frontUrl = process.env.REACT_APP_FRONT_URL;

type DashboardMenuLogoutProps = {
  isCollapsed: boolean;
};

export const DashboardMenuLogout: React.FC<DashboardMenuLogoutProps> = ({ isCollapsed }) => {
  const { t } = useTranslation(NsKey.Common)
  const auth = useAuth();

  const [isHovered, setIsHovered] = useState(false)

  const handleLogout = async () => {
    try {
      localStorage.clear();
      sessionStorage.clear();

      // Déclencher la déconnexion OIDC complète
      // Cela redirigera vers le serveur OIDC pour déconnecter l'utilisateur
      await auth.signoutRedirect({
        post_logout_redirect_uri: `${frontUrl}/bord`
      });

    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);

      auth.removeUser();
      localStorage.clear();
      sessionStorage.clear();

      window.location.href = `${frontUrl}/bord`;
    }
  };

  return (
    <button className={`relative h-24 justify-center text-white/70 hover:text-white w-full flex items-center p-3 rounded-xl transition-all duration-200 group
`}
      onClick={handleLogout}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <LogoutIcon className={`w-5 h-5 transition-transform duration-200`} />
      {
        !isCollapsed &&
        <span className="ml-3 font-medium tracking-wide">{t("COMMON.LABELS.LOGOUT")}</span>
      }

      <DashboardMenuItemTooltip
        label={t("COMMON.LABELS.LOGOUT")}
        isVisible={isCollapsed && isHovered}
      />
    </button>
  )
};
